/**
 * Standalone page for Translucence Chat Widget.
 * Designed to be opened in a popup window.
 */

import { Box, Typography } from "@mui/material";
import { useParams } from "react-router-dom";
import { ChatWidget } from "@app/features/translucenceChat";

export const TranslucenceChatPage = () => {
  const { planResultRootId, planResultTypeId } = useParams<{
    planResultRootId: string;
    planResultTypeId: string;
  }>();

  if (!planResultRootId || !planResultTypeId) {
    return (
      <Box sx={{ p: 3 }}>
        <Typography variant="par02Regular">
          Missing required parameters: planResultRootId and planResultTypeId
        </Typography>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        width: "100vw",
        height: "100vh",
        position: "relative",
        overflow: "hidden",
      }}
    >
      <ChatWidget
        planResultRootId={planResultRootId}
        planResultTypeId={planResultTypeId}
      />
    </Box>
  );
};

